//* Imported Dependencies
import React, { useContext, useState, useRef } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { Card, Grid, Form, Transition} from 'semantic-ui-react';
import moment from 'moment';

//* Imported Components
import { AuthContext } from '../context/auth';
import LikeButton from '../components/likeButton';
import DeleteButton from '../components/deleteButton';
import CommentButton from '../components/commentButton';

//* Imported GraphQL
import {FETCH_POST_QUERY, SUBMIT_COMMENT_MUTATION} from '../util/graphQL';

const SinglePost = props => {
  const postId = props.match.params.postId;
  const { user } = useContext(AuthContext);
  const commentInputRef = useRef(null);
  const [comment, setComment] = useState('');

  const { data: { getPost } ={}} = useQuery(FETCH_POST_QUERY, { variables: {postId} });
  const [submitComment] = useMutation(SUBMIT_COMMENT_MUTATION,{
    update: () => {
      setComment('');
      commentInputRef.current.blur();
    },
    variables: { postId, body: comment}
  });

  const deletePostCallback = () => props.history.push('/');
  const displayComments = (comments, id, createdAt) => {
    return (
    <Transition.Group>
      {comments.map(comment => (
        <Card fluid key={comment.id}>
          <Card.Content>
            {user && user.username === comment.username && (
              <DeleteButton postId={id} commentId={comment.id} />
            )}
            <Card.Header>{comment.username}</Card.Header>
            <Card.Meta>{moment(comment.createdAt).fromNow()}</Card.Meta>
            <Card.Description>{comment.body}</Card.Description>
          </Card.Content>
        </Card>
      ))}
    </Transition.Group>
    )
  };

  const commentInputCard = () => {
    return (
      <Card fluid>
        <Card.Content>
          <p>Post a Comment</p>
          <Form>
            <div className="ui action input fluid">
              <input type="text" placeholder="Comment..." name="comment" value={comment} onChange={e => setComment(e.target.value)} ref={commentInputRef}/>
              <button type="submit" className="ui button teal" disabled={comment.trim() === ''} onClick={submitComment}>Submit</button>
            </div>
          </Form>
        </Card.Content>
      </Card>
    )
  };

  let postMarkup;
  if (!getPost) {
    //TODO: Put a spinner here
    postMarkup = <p>Loading...</p>
  } else {
    const { id, body, createdAt, username, comments, likes, likeCount, commentCount } = getPost;
    postMarkup = (
      <Grid>
        <Grid.Row>
          {/* <Grid.Column width={2}>
            <Image
              src="https://react.semantic-ui.com/images/avatar/large/molly.png"
              size="small"
              float="right"
            />
          </Grid.Column> */}
          <Grid.Column width={10}>
            <Card fluid>
              <Card.Content>
                <Card.Header>{username}</Card.Header>
                <Card.Meta>{moment(createdAt).fromNow()}</Card.Meta>
                <Card.Description>{body}</Card.Description>
              </Card.Content>
              <hr />
              <Card.Content extra>
                <LikeButton user={user} post={{ id, likeCount, likes }} />
                <CommentButton user={user} post={{id, comments, commentCount}} /> 
                {user && user.username === username && ( <DeleteButton postId={id} callback={deletePostCallback} /> )}
              </Card.Content>
            </Card>
            {user && commentInputCard()}
            {displayComments(comments, id, createdAt)}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  return postMarkup;
}

export default SinglePost;